import peopleBackground from "@/shared/assets/backgrounds/people-background.png";
import assetSearchImage from "@/shared/assets/login/asset-search.jpg";
import estateExpertImage from "@/shared/assets/login/estate-expert.jpg";

import type { Story } from "@/pages/onboarding/components/StoryCarousel";

export const CLIENT_INVITE_STORIES: Story[] = [
  {
    id: "start",
    image: peopleBackground,
    title: "Start with what you have",
    description:
      "A few documents or even handwritten notes are enough, and Elayne guides you from there.",
  },
  {
    id: "asset-search",
    image: assetSearchImage,
    title: "Over $5M found with Elayne Asset Search",
    description:
      "Find bank accounts, insurance policies, retirement accounts, and other assets that might otherwise go undiscovered.",
  },
  {
    id: "attorney",
    image: estateExpertImage,
    title: "Built to work with your attorney",
    description:
      "What you add builds one organized record your attorney can review, so nothing gets lost in emails and calls.",
  },
];
